import axios from 'axios';
import { PRODUCT_HANDLE, SHOPIFY_PRODUCT_URL } from '@/shopify';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// GET /api/shopify/product -> { configured, storeDomain, product: { price, variantId, ... } | null }
export const fetchShopifyProduct = () =>
    axios
        .get(`${API}/shopify/product`, { params: { handle: PRODUCT_HANDLE } })
        .then((r) => r.data);

// POST /api/shopify/checkout -> { configured, checkoutUrl }
export const startShopifyCheckout = async (quantity = 1) => {
    const { data } = await axios.post(`${API}/shopify/checkout`, {
        handle: PRODUCT_HANDLE,
        quantity,
    });
    return data;
};

const CURRENCY_SYMBOLS = { USD: '$', EUR: '\u20AC', GBP: '\u00A3' };

export const formatPrice = (price) => {
    if (!price || price.amount == null) return null;
    const symbol = CURRENCY_SYMBOLS[price.currencyCode] || `${price.currencyCode} `;
    return `${symbol}${price.amount}`;
};

// Shared behaviour for every "Get ENGINE" button: open Shopify checkout when
// the store is connected, otherwise fall back to the placeholder product URL.
export const goToCheckout = async (event) => {
    event.preventDefault();
    try {
        const data = await startShopifyCheckout();
        if (data.configured && data.checkoutUrl) {
            window.location.href = data.checkoutUrl;
            return;
        }
    } catch (error) {
        console.error('Checkout failed, falling back to product URL', error);
    }
    window.location.href = SHOPIFY_PRODUCT_URL;
};
